<script setup>
import PageTitle from "../template/PageTitle.vue"
import TabStructure from './tabs/Structure.vue'

</script>
<template>
     <section>
        <PageTitle :main="$t('createIndicators')" sub="" imagem="add.png" />
        <TabStructure :isCreating="true"></TabStructure>
    </section>
</template>
<script>
export default {
    name: 'CreateIndicators',
    components: {TabStructure},
}
</script>
<style></style>